export default "__VITE_ASSET__szSUBkqn__"